export const SELLERS_ROUTE = '/sellers';

export const OUTLETS_ROUTE = '/outlets';

export const REPORTS_ROUTE = '/reports';

export const NOTIFICATION_ROUTE = '/notification';

export const CALENDAR_ROUTE = '/calendar';
